
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_av9zi_103",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_av9zi_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_av9zi_130",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_av9zi_1",
  "error": "awsui_error_14mhv_av9zi_103",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_av9zi_1",
  "root": "awsui_root_14mhv_av9zi_174",
  "label": "awsui_label_14mhv_av9zi_210",
  "info": "awsui_info_14mhv_av9zi_224",
  "description": "awsui_description_14mhv_av9zi_229",
  "constraint": "awsui_constraint_14mhv_av9zi_230",
  "hints": "awsui_hints_14mhv_av9zi_237",
  "constraint-has-error": "awsui_constraint-has-error_14mhv_av9zi_238",
  "secondary-control": "awsui_secondary-control_14mhv_av9zi_242",
  "controls": "awsui_controls_14mhv_av9zi_246",
  "label-hidden": "awsui_label-hidden_14mhv_av9zi_246",
  "control": "awsui_control_14mhv_av9zi_246",
  "error__message": "awsui_error__message_14mhv_av9zi_264",
  "visually-hidden": "awsui_visually-hidden_14mhv_av9zi_268"
};
  